module.exports = __webpack_public_path__ + "static/media/ic_line.18612852.svg";